import React from 'react';

const QuickLinks: React.FC = () => {
    return (
        <div style={sectionStyle}>
            <h2 style={headingStyle}>Quick Links</h2>
            <div style={linksContainerStyle}>
                <a href="/A_Iwas_Resume.pdf" target="_blank" rel="noopener noreferrer" className="glass-button" style={linkStyle}>Resume</a>
                <a href="https://www.linkedin.com/in/anlil-iwas-b7aa892a9" target="_blank" rel="noopener noreferrer" className="glass-button" style={linkStyle}>LinkedIn</a>
                <a href="https://github.com/Iwas1512" target="_blank" rel="noopener noreferrer" className="glass-button" style={linkStyle}>GitHub</a>
            </div>
        </div>
    );
};

const sectionStyle: React.CSSProperties = {
    marginBottom: '25px',
    width: '100%',
    maxWidth: '600px',
};

const headingStyle: React.CSSProperties = {
    color: 'white',
    fontSize: '18px',
    marginBottom: '10px',
    fontWeight: 'bold',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    paddingBottom: '5px',
};

const linksContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingLeft: '10px',
};

const linkStyle: React.CSSProperties = {
    color: 'white',
    textDecoration: 'none',
    fontSize: '16px',
    padding: '8px 16px',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    display: 'inline-block',
    cursor: 'pointer',
    width: 'fit-content',
    backgroundColor: 'transparent',
};

export default QuickLinks;